var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pricing-option-title",style:({backgroundColor: _vm.bgColor && _vm.bgColor.color})},[_c('p',{staticClass:"p-title"},[_vm._v(_vm._s(_vm.option.price))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.option.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }